/* eslint-disable import/no-webpack-loader-syntax */ import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import doubleTerminatedUrl from '../../../assets/gems/double_terminated.svg?inline';
export function DoubleTerminated({ ...props }) {
    return /*#__PURE__*/ _jsx("img", {
        ...props,
        src: doubleTerminatedUrl,
        alt: "DoubleTerminatedImage"
    });
}
